import { getAttributeValueByKey } from "../helpers/AttributeValueByKey";
import { Asset } from "./Asset";

export interface SwitchGear {
  id?: number;
  name: string;
  switchGearManufacturer?: string;
  switchGearType?: string;
  installDate?: Date | string;
  insulation?: string;
  operatingVoltage?: string;
  ratedVoltage?: string;
  panels: Panel[];
  assetType?: string;
}

export interface ExistingSwitchGear extends SwitchGear {
  id: number;
}

export const mapSwitchgearFromAsset = (asset: Asset): ExistingSwitchGear => ({
  id: asset.id,
  name: asset.name,
  installDate: asset.installDate,
  switchGearManufacturer: getAttributeValueByKey(asset.attributes, "SwitchGearManufacturer"),
  switchGearType: getAttributeValueByKey(asset.attributes, "SwitchGearType"),
  insulation: getAttributeValueByKey(asset.attributes, "Insulation"),
  operatingVoltage: getAttributeValueByKey(asset.attributes, "OperatingVoltage"),
  ratedVoltage: getAttributeValueByKey(asset.attributes, "RatedVoltage"),
  panels: [],
  assetType: asset.assetTypeKey,
});

export interface Panel {
  panelAssetId?: number;
  panelNo: string;
  name?: string;
  assetTag?: string;
}

export interface SwitchGearSubmission {
  hvSubstationId: number;
  switchgears: SwitchGear[];
}

export interface PanelSubmission {
  switchgearId: number;
  panels: Panel[];
}
